const sm2 = require('sm-crypto').sm2
const cipherMode = 1
export default {
  // 加密
  encrypt (text, key) {
    key = key || '047f6de6417e004b9f18fc202fa838e6202936f48ae40d43ecf11db14acd2165ea84eefcc195311b0b7b8d8a35e5cd4c53c163655255210eebe85e27c3d18ad9de'
    const enText = sm2.doEncrypt(text, key, cipherMode)
    return '04' + enText
  },
  // 解密
  decrypt (text, key) {
    key = key || '00b52355689ff8d974f4007a65645dc41ec072ddad8c4d0cb158fe15b1482d6bd8'
    const deText = sm2.doDecrypt(text.slice(2), key, cipherMode)
    return deText
  }
}
